export default "__VITE_ASSET__BufmMV7___"